var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1249,
    viewBox: "0 0 1440 1249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-59 136H255.358C258.01 136 260.554 137.054 262.429 138.929L421.571 298.071C423.446 299.946 424.5 302.49 424.5 305.142V812C424.5 817.523 428.977 822 434.5 822H1034.86C1037.51 822 1040.05 823.054 1041.93 824.929L1443.5 1226.5",
    stroke: "url(#paint0_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-22 3.5L69.5711 95.0711C71.4464 96.9464 72.5 99.49 72.5 102.142V474.5C72.5 480.023 76.9772 484.5 82.5 484.5H648.5C654.023 484.5 658.5 488.977 658.5 494.5V577C658.5 582.523 662.977 587 668.5 587H1008.5C1014.02 587 1018.5 582.523 1018.5 577V375.5C1018.5 369.977 1022.98 365.5 1028.5 365.5H1325.5C1331.02 365.5 1335.5 369.977 1335.5 375.5V495C1335.5 500.523 1339.98 505 1345.5 505H1760.5",
    stroke: "url(#paint1_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-102 861H208.858C211.51 861 214.054 862.054 215.929 863.929L541 1189",
    stroke: "url(#paint2_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-117 714H454.5C460.023 714 464.5 718.477 464.5 724V980C464.5 985.523 468.977 990 474.5 990H1486.5",
    stroke: "url(#paint3_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1497.5 197.5H1065.14C1062.49 197.5 1059.95 198.554 1058.07 200.429L970.929 287.571C969.054 289.446 968 291.99 968 294.642V635C968 640.523 963.523 645 958 645H730C724.477 645 720 649.477 720 655V1243.5",
    stroke: "url(#paint4_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-59 210.5H766C771.523 210.5 776 206.023 776 200.5V3.5",
    stroke: "url(#paint5_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-83.5 786.5H274.358C277.01 786.5 279.554 787.554 281.429 789.429L408.571 916.571C410.446 918.446 412.99 919.5 415.642 919.5H1583",
    stroke: "url(#paint6_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1492 764H1097.5C1091.98 764 1087.5 759.523 1087.5 754V289.142C1087.5 286.49 1086.45 283.946 1084.57 282.071L768.5 -34",
    stroke: "url(#paint7_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-64.5 589H277.5C283.023 589 287.5 584.523 287.5 579V350.642C287.5 347.99 288.554 345.446 290.429 343.571L464.571 169.429C466.446 167.554 468.99 166.5 471.642 166.5H902.358C905.01 166.5 907.554 165.446 909.429 163.571L1113 -40",
    stroke: "url(#paint8_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1501 661.5H1304.5C1298.98 661.5 1294.5 665.977 1294.5 671.5V858.5C1294.5 864.023 1290.02 868.5 1284.5 868.5H965C959.477 868.5 955 864.023 955 858.5V737C955 731.477 950.523 727 945 727H578.642C575.99 727 573.446 725.946 571.571 724.071L496.429 648.929C494.554 647.054 492.01 646 489.358 646H-53.5",
    stroke: "url(#paint9_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1501 324.5L1398.93 426.571C1397.05 428.446 1394.51 429.5 1391.86 429.5H901.142C898.49 429.5 895.946 430.554 894.071 432.429L800.929 525.571C799.054 527.446 796.51 528.5 793.858 528.5H167C161.477 528.5 157 532.977 157 538.5V1249",
    stroke: "url(#paint10_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.5 962H72.5C78.0228 962 82.5 957.523 82.5 952V546.642C82.5 543.99 83.5536 541.446 85.4289 539.571L182.071 442.929C183.946 441.054 186.49 440 189.142 440H725.358C728.01 440 730.554 438.946 732.429 437.071L1052.07 117.429C1053.95 115.554 1056.49 114.5 1059.14 114.5H1544",
    stroke: "url(#paint11_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1525.5 600H1194.5C1188.98 600 1184.5 595.523 1184.5 590V-33.5",
    stroke: "url(#paint12_linear_745_15673)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-166.5 658.5L12.0711 479.929C13.9464 478.054 16.49 477 19.1421 477H580.358C583.01 477 585.554 478.054 587.429 479.929L797.071 689.571C798.946 691.446 801.49 692.5 804.142 692.5H1145.5C1151.02 692.5 1155.5 688.023 1155.5 682.5V487C1155.5 481.477 1159.98 477 1165.5 477H1564.5",
    stroke: "#A49CFF",
    strokeOpacity: 0.1,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 714.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 646.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 136.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379,
    cy: 255.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 439.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 527.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 645.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 713.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 726.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 821.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 968,
    cy: 515.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 968,
    cy: 429.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 134.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986,
    cy: 182.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1031,
    cy: 227.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185,
    cy: 197.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185,
    cy: 114.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185,
    cy: 477.5,
    r: 4,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_745_15673)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 645.5,
    r: 4,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_745_15673",
    x: 396,
    y: 617.5,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 14,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_745_15673"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_745_15673"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_745_15673",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_745_15673",
    x1: 692.25,
    y1: 136,
    x2: 692.25,
    y2: 1226.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_745_15673",
    x1: 869.25,
    y1: 3.5,
    x2: 869.25,
    y2: 587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_745_15673",
    x1: 219.5,
    y1: 861,
    x2: 219.5,
    y2: 1189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_745_15673",
    x1: 684.75,
    y1: 714,
    x2: 684.75,
    y2: 990,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_745_15673",
    x1: 1108.75,
    y1: 197.5,
    x2: 1108.75,
    y2: 1243.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_745_15673",
    x1: 358.5,
    y1: 3.5,
    x2: 358.5,
    y2: 210.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_745_15673",
    x1: 749.75,
    y1: 786.5,
    x2: 749.75,
    y2: 919.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_745_15673",
    x1: 1130.25,
    y1: -34,
    x2: 1130.25,
    y2: 764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_745_15673",
    x1: 524.25,
    y1: -40,
    x2: 524.25,
    y2: 589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_745_15673",
    x1: 723.75,
    y1: 646,
    x2: 723.75,
    y2: 868.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_745_15673",
    x1: 829,
    y1: 324.5,
    x2: 829,
    y2: 1249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_745_15673",
    x1: 738.75,
    y1: 114.5,
    x2: 738.75,
    y2: 962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_745_15673",
    x1: 1355,
    y1: -33.5,
    x2: 1355,
    y2: 600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D171FF",
    stopOpacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.c5e8ec3c74b815995c01f0562940b5ed.svg";
export { ForwardRef as ReactComponent };